export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11536.07654c3d.jpg";